import { type IBadge } from '~/domain/RecommendedProfessionals/recommendedProfessionalsTypes';
import {
  IProfessionalProfile,
  IProfessionalProfileApi,
  IProfessionalProfileBadgeApi,
} from '../types/IProfessionalProfile';

/**
 * Flattens a profile badge onto the shape every other professional list uses.
 *
 * The office is the audience here, so the dentist copy is preferred and the
 * hygienist copy is the fallback — matching what the pool endpoints already
 * flatten to for the same badge.
 */
const toBadge = (badge: IProfessionalProfileBadgeApi): IBadge => ({
  type: badge.type,
  level: badge.level,
  imageUrl: badge.imageUrl,
  label: badge.label,
  popupTitle: badge.popupTitleDnt ?? badge.popupTitleHyg ?? badge.label,
  popupDescription: badge.popupDescriptionDnt ?? badge.popupDescriptionHyg ?? '',
  popupImageMobile: badge.popupImageMobileDnt ?? badge.popupImageMobileHyg,
  popupImageWeb: badge.popupImageWebDnt ?? badge.popupImageWebHyg,
  toNextRankRequirement: badge.toNextRankRequirement,
  popupTitleIcon: badge.popupTitleIcon,
});

const toProfessionalProfile = (api: IProfessionalProfileApi): IProfessionalProfile => ({
  id: api.id,
  fullName: api.full_name ?? [api.first_name, api.last_name].filter(Boolean).join(' '),
  profileImage: api.profile_image ?? '',
  averageRating: api.average_rating ?? 0,
  badges: (api.badges ?? []).map(toBadge),
  education: api.professional_info?.education ?? {},
});

export const professionalProfileAdapter = { toProfessionalProfile };
